// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Cn = require("re-classnames/src/Cn.bs.js");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Util_Css = require("../../util/Util_Css.bs.js");
var Atom_Cell = require("./Atom_Cell.bs.js");
var Atom_Text = require("./Atom_Text.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Atom_Text_Ds = require("./Atom_Text_Ds.bs.js");
var Particle_Css = require("../particle/Particle_Css.bs.js");
var Atom_Text_Css = require("./Atom_Text_Css.bs.js");
var Atom_Icon_Internal = require("./icon/Atom_Icon_Internal.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../particle/Particle_Spacer_Ds.bs.js");
var Particle_Border_Css = require("../particle/Particle_Border_Css.bs.js");
var Particle_Screen_Css = require("../particle/Particle_Screen_Css.bs.js");
var Particle_Spacer_Css = require("../particle/Particle_Spacer_Css.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");
var Particle_Background_Css = require("../particle/Particle_Background_Css.bs.js");
var Particle_Screen_Constants = require("../particle/Particle_Screen_Constants.bs.js");

var _map = {"addressLevel1":"address-level1","addressLine1":"address-line1","currentPassword":"current-password","email":"email","familyName":"family-name","givenName":"given-name","newPassword":"new-password","off":"off","postalCode":"postal-code"};

function autoCompleteToJs(param) {
  return _map[param];
}

function makeStyle(backgroundOpt, blockSpaceOpt, borderOpt, textStyleOpt, param) {
  var background = backgroundOpt !== undefined ? Caml_option.valFromOption(backgroundOpt) : Particle_Background_Ds.transparent;
  var blockSpace = blockSpaceOpt !== undefined ? Caml_option.valFromOption(blockSpaceOpt) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("XS"));
  var border = borderOpt !== undefined ? borderOpt : /* None */19;
  var textStyle = textStyleOpt !== undefined ? textStyleOpt : Atom_Text_Ds.textfield;
  return {
          background: background,
          blockSpace: blockSpace,
          border: border,
          icon: undefined,
          iconSize: undefined,
          placeholderSize: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M"),
          textStyle: textStyle
        };
}

function make(style) {
  if (style) {
    return makeStyle(Caml_option.some(Particle_Background_Ds.inputMona), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), undefined, Atom_Text_Ds.Mona.makeTextfield, undefined);
  } else {
    return makeStyle(undefined, undefined, {
                TAG: /* Textfield */7,
                _0: /* Inactive */1
              }, undefined, undefined);
  }
}

function view(param) {
  return {
          background: param.background,
          blockSpace: param.blockSpace,
          border: param.border,
          icon: param.icon,
          iconSize: param.iconSize,
          placeholderSize: param.placeholderSize,
          textStyle: param.textStyle
        };
}

function toCss(dsStyle) {
  var match = view(dsStyle);
  var svgRules = Belt_Option.map(match.icon, (function (param) {
          return [
                  CssJs.pointerEvents("none"),
                  CssJs.position("absolute"),
                  CssJs.lineHeight(CssJs.zero),
                  CssJs.right(Particle_Css.spacerSizeOutside("M")),
                  CssJs.top(CssJs.pct(50)),
                  CssJs.transform({
                        NAME: "translateY",
                        VAL: CssJs.pct(-50)
                      })
                ];
        }));
  var placeholderSizeRules = [CssJs.selector("::placeholder", Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(Particle_Css.font_size, param);
              }), match.placeholderSize))];
  var blockSpace = Particle_Screen_Css.toRules(undefined, undefined, Particle_Spacer_Css.toCss, match.blockSpace);
  return {
          blockSpace: blockSpace,
          border: match.border,
          iconWrapperRules: svgRules,
          placeholderSizeRules: placeholderSizeRules
        };
}

function Atom_Textfield_Mona$Internal(Props) {
  var ariaLabel = Props.ariaLabel;
  var autoComplete = Props.autoComplete;
  var title = Props.title;
  var type_ = Props.type_;
  var value = Props.value;
  var placeholder = Props.placeholder;
  var onChange = Props.onChange;
  var requiredOpt = Props.required;
  var readOnlyOpt = Props.readOnly;
  var displayOrder = Props.displayOrder;
  var rules = Props.rules;
  var styleOpt = Props.style;
  var autoFocus = Props.autoFocus;
  var autoSize = Props.autoSize;
  var focusOutlineOpt = Props.focusOutline;
  var required = requiredOpt !== undefined ? requiredOpt : false;
  var readOnly = readOnlyOpt !== undefined ? readOnlyOpt : false;
  var style = styleOpt !== undefined ? styleOpt : /* Default */0;
  var focusOutline = focusOutlineOpt !== undefined ? focusOutlineOpt : ({
        TAG: /* Textfield */7,
        _0: /* Active */0
      });
  var match = React.useState(function () {
        return Belt_Option.getWithDefault(value, "");
      });
  var setInternalValue = match[1];
  React.useEffect((function () {
          Curry._1(setInternalValue, (function (param) {
                  return Belt_Option.getWithDefault(value, "");
                }));
        }), [value]);
  var dsStyle = make(style);
  var match$1 = view(dsStyle);
  var icon = match$1.icon;
  var match$2 = toCss(dsStyle);
  var iconWrapperRules = match$2.iconWrapperRules;
  var textClass = Particle_Screen_Css.toCss2((function (a) {
          return a;
        }), Atom_Text_Css.toCss(Atom_Text_Ds.view(match$1.textStyle)));
  var __x = Belt_Array.concat(Particle_Background_Css.toCss(match$1.background), [
        CssJs.border(CssJs.px(1), "solid", "transparent"),
        CssJs.width(CssJs.pct(100)),
        CssJs.focus(Particle_Border_Css.toCss(focusOutline)),
        CssJs.active(Particle_Border_Css.toCss(focusOutline))
      ]);
  var baseCss = CssJs.style(__x);
  var baseClassname = CssJs.merge([baseCss]);
  var handleChange = function ($$event) {
    var value = $$event.target.value;
    if (onChange !== undefined) {
      Curry._1(onChange, value);
    }
    Curry._1(setInternalValue, value);
  };
  var autoComplete$1 = Belt_Option.map(autoComplete, autoCompleteToJs);
  var border = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, match$2.border);
  var tmp = {
    border: border,
    width: Particle_Screen_Constants.oneHundredPctWidth,
    children: null
  };
  if (autoSize !== undefined) {
    tmp.autoSize = Caml_option.valFromOption(autoSize);
  }
  if (displayOrder !== undefined) {
    tmp.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  if (rules !== undefined) {
    tmp.rules = Caml_option.valFromOption(rules);
  }
  var tmp$1 = {
    className: Cn.fromList({
          hd: CssJs.style(match$2.placeholderSizeRules),
          tl: {
            hd: CssJs.style(match$2.blockSpace),
            tl: {
              hd: textClass,
              tl: {
                hd: baseClassname,
                tl: /* [] */0
              }
            }
          }
        }),
    placeholder: Belt_Option.getWithDefault(placeholder, ""),
    readOnly: readOnly,
    required: required,
    type: Belt_Option.getWithDefault(type_, "text"),
    value: match[0],
    onChange: handleChange
  };
  if (ariaLabel !== undefined) {
    tmp$1["aria-label"] = Caml_option.valFromOption(ariaLabel);
  }
  if (title !== undefined) {
    tmp$1.title = Caml_option.valFromOption(title);
  }
  if (autoComplete$1 !== undefined) {
    tmp$1.autoComplete = Caml_option.valFromOption(autoComplete$1);
  }
  if (autoFocus !== undefined) {
    tmp$1.autoFocus = Caml_option.valFromOption(autoFocus);
  }
  var tmp$2;
  if (icon !== undefined && iconWrapperRules !== undefined) {
    var tmp$3 = {
      icon: icon
    };
    if (match$1.iconSize !== undefined) {
      tmp$3.size = Caml_option.valFromOption(match$1.iconSize);
    }
    tmp$2 = React.createElement(Atom_Text.Unsafe.make, {
          kind: "span",
          children: React.createElement(Atom_Icon_Internal.make, tmp$3),
          rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, iconWrapperRules)
        });
  } else {
    tmp$2 = null;
  }
  return React.createElement(Atom_Cell.make, tmp, React.createElement("input", tmp$1), tmp$2);
}

function Atom_Textfield_Mona$Mona(Props) {
  var ariaLabel = Props.ariaLabel;
  var autoCompleteOpt = Props.autoComplete;
  var onChange = Props.onChange;
  var placeholder = Props.placeholder;
  var readOnlyOpt = Props.readOnly;
  var requiredOpt = Props.required;
  var title = Props.title;
  var type_ = Props.type_;
  var value = Props.value;
  var autoComplete = autoCompleteOpt !== undefined ? autoCompleteOpt : "off";
  var readOnly = readOnlyOpt !== undefined ? readOnlyOpt : false;
  var required = requiredOpt !== undefined ? requiredOpt : false;
  var tmp = {
    autoComplete: autoComplete,
    required: required,
    readOnly: readOnly,
    style: /* Mona */1
  };
  if (ariaLabel !== undefined) {
    tmp.ariaLabel = Caml_option.valFromOption(ariaLabel);
  }
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  if (type_ !== undefined) {
    tmp.type_ = Caml_option.valFromOption(type_);
  }
  if (value !== undefined) {
    tmp.value = Caml_option.valFromOption(value);
  }
  if (placeholder !== undefined) {
    tmp.placeholder = Caml_option.valFromOption(placeholder);
  }
  if (onChange !== undefined) {
    tmp.onChange = Caml_option.valFromOption(onChange);
  }
  return React.createElement(Atom_Textfield_Mona$Internal, tmp);
}

var Mona = {
  make: Atom_Textfield_Mona$Mona
};

exports.Mona = Mona;
/* CssJs Not a pure module */
